<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 48 37"
    :fill="color"
    :style="{ color }"
  >
    <defs><path id="a" d="M0 .801h48V36H0z" /></defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(0 .199)">
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <path
          fill="#2FAB60"
          d="M46.398 32.63c0 .976-.793 1.772-1.773 1.772H3.375c-.98 0-1.773-.796-1.773-1.773V4.176c0-.98.793-1.773 1.773-1.773h41.25c.98 0 1.773.793 1.773 1.773V32.63zM44.625.8H3.375A3.376 3.376 0 0 0 0 4.176V32.63A3.376 3.376 0 0 0 3.375 36h41.25A3.376 3.376 0 0 0 48 32.63V4.175A3.376 3.376 0 0 0 44.625.801z"
          mask="url(#b)"
        />
      </g>
      <path
        fill="#2FAB60"
        d="M12.8 24.2H5.603a.799.799 0 0 0-.801.8.8.8 0 0 0 .8.801h7.2c.44 0 .8-.36.8-.8a.802.802 0 0 0-.8-.802M23.2 24.2H16a.802.802 0 0 0 0 1.601h7.2a.802.802 0 0 0 0-1.602M6.398 28.2h-.796a.799.799 0 0 0-.801.8.8.8 0 0 0 .8.801h.797a.8.8 0 0 0 .8-.8.799.799 0 0 0-.8-.802M11.2 28.2H9.601a.799.799 0 0 0-.8.8.8.8 0 0 0 .8.801H11.2a.802.802 0 0 0 0-1.602M15.2 28.2h-.802a.798.798 0 0 0-.796.8c0 .441.355.801.796.801h.801a.802.802 0 0 0 0-1.602M20 28.2h-1.602a.798.798 0 0 0-.796.8c0 .441.355.801.796.801H20c.441 0 .801-.36.801-.8a.802.802 0 0 0-.801-.802M22.633 28.434a.837.837 0 0 0-.235.566c0 .207.09.414.235.567a.833.833 0 0 0 .566.234c.207 0 .418-.09.57-.234A.86.86 0 0 0 24 29a.855.855 0 0 0-.23-.566c-.304-.297-.851-.297-1.136 0M38.398 30.602c-.504 0-.984-.105-1.43-.277a5.567 5.567 0 0 0 0-7.45 3.983 3.983 0 0 1 1.43-.273c2.207 0 4 1.793 4 4 0 2.203-1.793 4-4 4m-9.598-4c0-2.207 1.793-4 4-4 .504 0 .985.102 1.43.273a5.567 5.567 0 0 0 0 7.45 3.96 3.96 0 0 1-1.43.277c-2.207 0-4-1.797-4-4m8 0a3.99 3.99 0 0 1-1.199 2.848 3.977 3.977 0 0 1 0-5.7 3.992 3.992 0 0 1 1.2 2.852M38.397 21c-1.02 0-1.973.278-2.797.758a5.561 5.561 0 0 0-2.8-.758 5.606 5.606 0 0 0-5.602 5.602A5.605 5.605 0 0 0 32.8 32.2c1.02 0 1.973-.278 2.801-.758.824.48 1.777.758 2.797.758A5.606 5.606 0 0 0 44 26.602 5.607 5.607 0 0 0 38.398 21M6.605 9h3.016c-.008.066-.019.133-.019.203v1.399H6.398V9.203c0-.113.094-.203.207-.203zm10.79 0c.113 0 .207.09.207.203v1.192a.209.209 0 0 1-.207.207h-2.79c-.996 0-1.804.808-1.804 1.8v4.395a.204.204 0 0 1-.203.203h-1.196a.204.204 0 0 1-.203-.203V9.203c0-.113.094-.203.203-.203h5.993zm0 8h-3.016c.008-.066.019-.133.019-.203v-1.399h3.204v1.399a.205.205 0 0 1-.207.203zm.207-3.199h-3.204v-1.399c0-.109.094-.203.207-.203h2.79c.07 0 .136-.012.207-.019v1.621zM6.398 16.797v-1.399h3.204v1.399c0 .07.011.137.019.203H6.605a.205.205 0 0 1-.207-.203zm0-2.996h3.204v-1.602H6.398v1.602zm.207 4.801h10.79c.996 0 1.804-.813 1.804-1.805V9.203c0-.992-.808-1.805-1.804-1.805H6.605c-.996 0-1.804.813-1.804 1.805v7.594c0 .992.808 1.805 1.804 1.805z"
      />
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'CreditcardSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
